/**
 * Handles a queue for multiple concurrent async operations
 */
export default class ConcurrentQueue<T> {
  private queue: Array<() => Promise<T>> = []
  private counter = 0
  private maxConcurrency: number

  constructor (maxConcurrency: number) {
    this.maxConcurrency = maxConcurrency
  }

  enqueue (task: () => Promise<T>) {
    this.queue.push(task)
    this.runNext()
  }

  private runNext () {
    while (this.counter < this.maxConcurrency && this.queue.length > 0) {
      const task = this.queue.shift()
      if (task) {
        this.counter++
        task().finally(() => {
          this.counter--
          this.runNext()
        })
      }
    }
  }
}
